import React from 'react';
import Cart from '@px/cart-icon';
import { useIntl } from '@godaddy/react-mintl';
import PropTypes from 'prop-types';
import { useUserData, getUxData, useRootProps } from './UserDataProvider';
import { TYPES } from '../lib/types';

import './CartWrapper.css';

const CartWrapper = ({ app, cartItems, appEid, cartLink, CartComponent }) => {
  const { market, urls, requestedHeader } = useRootProps();
  const uxData = getUxData();
  const { userData } = useUserData();
  const { items = 0 } = userData;
  const { formatMessage } = useIntl();
  const pageEid = appEid.extend('cart');
  const cartLinkEid = pageEid('cart_link.link.click');

  const messages = {
    'Shared:UtilityBar:Cart':
      formatMessage({ id: 'Shared:UtilityBar:Cart' }),
    'Shared:UtilityBar:Cart:EmptyCartMessage':
      formatMessage({ id: 'Shared:UtilityBar:Cart:EmptyCartMessage' }),
    'Shared:UtilityBar:Cart:ItemsInCartMessage':
      formatMessage({ id: 'Shared:UtilityBar:Cart:ItemsInCartMessage' })
  };

  const header = Object.keys(TYPES).find(key => TYPES[key] === requestedHeader);

  const cartProps = {
    ...uxData,
    messages,
    market,
    items: cartItems || items,
    checkout: cartLink || urls.checkout.href,
    hideCheckoutNow: true,
    showEmpty: true,
    eid: cartLinkEid,
    className: 'cart-link',
    appKey: app,
    manifest: `applicationsidebar-${header}`
  };

  return (
    <div className='cart-wrapper global-nav-margin'>
      { CartComponent ? CartComponent : <Cart { ...cartProps } /> }
    </div>
  );
};

CartWrapper.propTypes = {
  cartItems: PropTypes.number,
  CartComponent: PropTypes.node,
  cartLink: PropTypes.string,
  items: PropTypes.number,
  appEid: PropTypes.func,
  app: PropTypes.string
};

export default CartWrapper;
